"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var TextArea_1 = __importDefault(require("../../../TextArea"));
var options = [
    'community_group',
    'from_a_friend',
    'from_a_doctor',
    'newsletter',
    'workshop',
    'energy_cafe',
    'sail',
    'live_well_project',
];
var ProjectServiceInput = function () {
    var _a, _b;
    var trans = __2.useSemantics().trans;
    var _c = formik_1.useFormikContext(), values = _c.values, errors = _c.errors;
    var selected = values.project.how_did_you_hear || [];
    return (react_1.default.createElement(__1.FormControl, { flush: true, errors: ((_a = errors.project) === null || _a === void 0 ? void 0 : _a.how_did_you_hear) || [], label: trans('project:slhh::labels.how-did-you-hear'), other: react_1.default.createElement(__1.FormControl, { showOther: selected.indexOf('community_group') > -1, errors: (_b = errors.project) === null || _b === void 0 ? void 0 : _b.how_did_you_hear_other, label: trans('project:slhh::enum.how-did-you-hear-other') },
            react_1.default.createElement(TextArea_1.default, { name: "project.how_did_you_hear_other", maxLength: 5000 })) },
        react_1.default.createElement("div", { className: "flex flex-col" }, options.map(function (key) { return (react_1.default.createElement(__1.Checkbox, { key: "project.how_did_you_hear." + key, name: "project.how_did_you_hear", label: trans("project:slhh::enum.how-did-you-hear." + key), value: key })); }))));
};
exports.default = ProjectServiceInput;
//# sourceMappingURL=ProjectServiceInput.js.map